import { create } from 'zustand'

interface ConversationStore {
   conversationData: any[]
   lastUpdate: string | null
   updateConversation: (data: any[]) => void
   setLastUpdate: (timestamp: string) => void
}

export const useConversationStore = create<ConversationStore>((set) => ({
   conversationData: [],
   lastUpdate: null,
   updateConversation: (data) => set({ conversationData: data }),
   setLastUpdate: (timestamp) => set({ lastUpdate: timestamp }),
}))
